/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from 'react';
import Select from 'react-select';

const customStyles = {
  color: 'black',
  control: (provided, state) => ({
    ...provided,
    minHeight: '35px',
    height: '35px',
  }),
  menu: base => ({
    ...base,
    marginTop: 0,
    color: '#000000',
  }),
  indicatorSeparator: state => ({
    display: 'none',
  }),
};

class Filter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentFilterKey: Object.keys(this.props.masterFilterKeys)[0],
    };
  }

  renderFilter() {
    const filterValues = this.props.masterFilterKeys[this.state.currentFilterKey];
    return (
      <div className="filterContainer">
        <div className="filterByContainer">
          <p>Filter By: </p>
          <Select
            className="feed-filter"
            value={{ value: this.state.currentFilterKey, label: this.state.currentFilterKey }}
            onChange={(e) => { this.setState({ currentFilterKey: e.value }); }}
            options={Object.keys(this.props.masterFilterKeys).map((k) => { return { value: k, label: k }; })}
            styles={customStyles}
            isSearchable={false}
          />
        </div>
        <div className="filterOptionContainer">
          {
          filterValues && filterValues.map((v) => {
            return (
              <div
                key={v}
                onClick={async () => {
                  try {
                    const filter = await this.props.updateFilter(this.state.currentFilterKey, v, this.props.filter);
                    await this.props.getUsers(filter);
                    const promises = Object.entries(this.props.users).map(([email, user]) => {
                      return this.props.getProfilePhoto(
                        user.answers?.profile_photo?.answer,
                        email,
                      );
                    });
                    await Promise.all(promises);
                  } catch (error) {
                    console.log(error);
                  }
                }}
                className={`filterOption ${this.props.filter[this.state.currentFilterKey] && this.props.filter[this.state.currentFilterKey].has(v) ? 'selected' : ''}`}
              >
                {v}
              </div>
            );
          })
          }
        </div>
      </div>
    );
  }

  render() {
    return (
      <>
        {this.renderFilter()}
      </>
    );
  }
}

export default Filter;
